import { render, staticRenderFns } from "./PointReceipt.vue?vue&type=template&id=4ad08b32&scoped=true"
import script from "./PointReceipt.vue?vue&type=script&lang=js"
export * from "./PointReceipt.vue?vue&type=script&lang=js"
import style0 from "./PointReceipt.vue?vue&type=style&index=0&id=4ad08b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad08b32",
  null
  
)

export default component.exports